if (!customElements.get('pop-up-mini')) {
  class PopupMini extends HTMLElement {
      constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.innerHTML = `
          <style>
            .rotate-text {
              position: fixed;
              left: 0;
              top: 60%;
              transform: translateY(-50%) rotate(-90deg);
              transform-origin: top left;
              background-color: #f39c12;
              color: white;
              font-size: 16px;
              font-weight: bold;
              white-space: nowrap;
              z-index: 1000; /* 确保元素在其他内容之上 */
              display: flex;
              align-items: center;
              display:none;
              cursor:pointer;
            }
            .rotate-text.activated.open {
              display: flex;
            }
            .close-button {
              position: absolute;
              width: 20px;
              height: 20px;
              color: white;
              cursor: pointer;
              bottom: 0;
              right: 0;
              transform: translateX(50%) translateY(50%);
            }
          </style>
          <div class="rotate-text open">
            <div id="pop-up-mini-content" style="padding: 10px">Get a Free Cat Bowl</div>
            <div class="close-button" id="closeButton">
              <svg
                id="Layer_1"
                style="enable-background: new 0 0 128 128"
                version="1.1"
                viewBox="0 0 128 128"
                xml:space="preserve"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <style type="text/css">
                  .st0 {
                    fill: #c93636;
                  }
                  .st1 {
                    fill: #ffffff;
                  }
                </style>
                <circle class="st0" cx="64" cy="64" r="64" />
                <path
                  class="st1"
                  d="M100.3,90.4L73.9,64l26.3-26.4c0.4-0.4,0.4-1,0-1.4l-8.5-8.5c-0.4-0.4-1-0.4-1.4,0L64,54.1L37.7,27.8c-0.4-0.4-1-0.4-1.4,0l-8.5,8.5c-0.4,0.4-0.4,1,0,1.4L54,64L27.7,90.3c-0.4,0.4-0.4,1,0,1.4l8.5,8.5c0.4,0.4,1.1,0.4,1.4,0L64,73.9l26.3,26.3c0.4,0.4,1.1,0.4,1.5,0.1l8.5-8.5C100.7,91.4,100.7,90.8,100.3,90.4z"
                />
              </svg>
            </div>
          </div>
        `;
      }

      connectedCallback() {
        this.shadowRoot.getElementById('closeButton').addEventListener('click', this.close.bind(this));
        const popup = document.querySelector('pop-up');
        if(popup){
          const formSuccess = popup.querySelector('.alert.bg-success-bg.text-success-text');
          if(formSuccess){
            this.close();
            return;
          }
          // 定义MutationObserver回调函数
          const observerCallback = (mutationsList, observer) => {
            for (const mutation of mutationsList) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
                // console.log('mini -> popup.hasOpen',popup.hasAttribute('open'));
                if (popup.hasAttribute('open')) {
                  this.setCookie('pop-up-mini-activated','activated',400);
                  this.shadowRoot.querySelector('.rotate-text').classList.add('activated');  
                  this.shadowRoot.querySelector('.rotate-text').classList.remove('open');  
                } else {
                  this.shadowRoot.querySelector('.rotate-text').classList.add('open');  
                }
              }
            }
          };
      
          // 创建MutationObserver实例
          const observer = new MutationObserver(observerCallback);
      
          // 配置MutationObserver监听的内容
          const observerOptions = {
            attributes: true, // 监听属性变化
            attributeFilter: ['open'] // 仅监听open属性
          };
      
          // 启动观察
          observer.observe(popup, observerOptions);
          // console.log('mini -> getCookie',this.getCookie('pop-up-mini-activated'));
          // console.log('popup -> getCookie',this.getCookie(popup.cookie));
          if(this.getCookie('pop-up-mini-activated') && this.getCookie(popup.cookie) == 'true'){
            // console.log('mini -> show')
            this.shadowRoot.querySelector('.rotate-text').classList.add('activated');  
          }
          
          this.shadowRoot.getElementById('pop-up-mini-content').addEventListener('click',(evt)=>{
            evt.preventDefault();
            popup.open();
            // console.log('mini -> popup.open');
          });
        }
        
        
      }

      disconnectedCallback() {
        this.shadowRoot.getElementById('closeButton').removeEventListener('click', this.close.bind(this));
      }


      /**
       * Sets a cookie.
       * @param {string} name - Name for the cookie.
       * @param {string} value - Value for the cookie.
       * @param {number} days - Number of days until the cookie should expire.
       */
      setCookie(name, value, days) {
        let expires = '';
      
        if (days) {
          const date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = `; expires=${date.toUTCString()}`;
        }
      
        document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=/; SameSite=None; Secure`;
      }
      
      /**
       * Gets the value of a cookie (if it exists).
       * @param {string} name - Name of the cookie.
       * @returns {?string}
       */
      getCookie(name) {
        const cookieString = `; ${document.cookie}`;
        const cookies = cookieString.split(`; ${name}=`);
      
        if (cookies.length === 2) {
          return cookies.pop().split(';').shift();
        }
      
        return null;
      }

      close() {
        this.shadowRoot.querySelector('.rotate-text').classList.remove('activated');
        this.setCookie('pop-up-mini-activated','',400);
      }
    }

    customElements.define('pop-up-mini', PopupMini);
}